   <template> 
    <b-container>
        <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
        <b-alert :show = "showDismissibleAlert" dismissible 
            @dismissed="showDismissibleAlert=false"
            :variant="variant">
            {{alertText}}
        </b-alert>
        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
           <b-row>
                <b-col md="6" sm="12" class="mt-2">
                    <p style="font-size: 17px;color:#2284ab;">Employer Details</p>
                    <p></p>
                    <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;">
                    <b-form-group id="ing1" horizontal
                            label="Working Status <span style='color:red'>*</span>" label-size="sm"
                            label-for="inp1">
                            <b-form-select id="inp1"
                                :options="workingStatus"
                                required size="sm"
                                v-model="form.UserExprienceDetails.workingStatus">
                        </b-form-select>  
                    </b-form-group>
                    <b-form-group id="ing2" horizontal
                            label="Name of the Agency<span style='color:red'>*</span>" label-size="sm"
                            label-for="inp2">
                        <b-form-input id="inp2"
                            type="text"
                            required size="sm"
                            v-model="form.UserExprienceDetails.AgencyName"
                            placeholder="Name of the Agency"></b-form-input>   
                    </b-form-group>
                    <b-form-group id="ing3" horizontal
                            label="Address of the Agency<span style='color:red'>*</span>" label-size="sm"
                            label-for="inp3">
                        <b-form-input id="inp3"
                            type="text"
                            v-model="form.UserExprienceDetails.AgencyAddress"
                            required size="sm"
                            placeholder="Address of the Agency"></b-form-input>    
                    </b-form-group>
                    <b-form-group id="ing4" horizontal 
                             label-size="sm" label="Agency Contact No<span style='color:red'>*</span>">
                        <b-form-input id="inp4"
                            type="text"
                            v-model="form.UserExprienceDetails.AgencyContactNo"
                            required size="sm"
                            placeholder="Agency Contact No"></b-form-input>
                    </b-form-group>
                    <b-form-group id="ing5" horizontal
                            label="Pasara License No" label-size="sm"
                            label-for="inp5">
                        <b-form-input id="inp5"
                            type="text"
                            v-model="form.UserExprienceDetails.PasaraLicense"
                            size="sm"
                            placeholder="Pasara License No"></b-form-input>    
                    </b-form-group>
                    <b-form-group id="ing6" horizontal
                            label="Validaty Date" label-size="sm"
                            label-for="inp6">
                        <!-- <b-form-input id="inp6"
                            type="date"
                            v-model="form.UserExprienceDetails.PasaraValidityDate"
                            required size="sm"
                            placeholder="Validaty Date"></b-form-input>     -->
                        <date-picker v-model="PasaraValidityDate" format="DD-MM-YYYY" lang="en" required size="small"></date-picker> 
                    </b-form-group>
                    <b-form-group id="ing7" horizontal 
                            label="Name of the Principal Employer<span style='color:red'>*</span>" label-size="sm"
                            label-for="inp7">
                        <b-form-input id="inp7"
                            type="text"
                            v-model="form.UserExprienceDetails.PrincipalEmployerName"
                            size="sm"
                            placeholder="Name of the Principal Employer"
                            :disabled="getUser.RegistrationType!=4"
                            
                            ></b-form-input>    
                    </b-form-group>
                    <b-form-group id="ing8" horizontal
                            label="Principal Employer Address" label-size="sm"
                            label-for="inp8">
                        <b-form-input id="inp8"
                            type="text"
                            v-model="form.UserExprienceDetails.PrincipalEmployerAddress"
                            required size="sm"
                            placeholder="Principal Employer Address"></b-form-input>    
                    </b-form-group>
                    <b-form-group id="ing9" horizontal
                            label="Location of Work Place" label-size="sm"
                            label-for="inp9">
                        <b-form-input id="inp9"
                            type="text"
                            v-model="form.UserExprienceDetails.WorkingLocation"
                            required size="sm"
                            placeholder="Location of Work Place"></b-form-input>    
                    </b-form-group>
                    <b-form-group id="ing10" horizontal
                            label="Principal Employer Contact No." label-size="sm"
                            label-for="inp10">
                        <b-form-input id="inp10"
                            type="text"
                            v-model="form.UserExprienceDetails.PrincipalContactNo"
                            required size="sm" min="100000000000000" max="999999999999999"
                            placeholder="Principal Employer Contact No."></b-form-input>    
                    </b-form-group>
                    <b-form-group id="ing11" horizontal
                            label="Nature Of Appointment" label-size="sm"
                            label-for="inp11">
                            <b-form-select id="inp11"
                                :options="apntnature"
                                required size="sm"
                                v-model="form.UserExprienceDetails.AppointmentType">
                        </b-form-select> 
                    </b-form-group>
                    </div>
                </b-col>
                <b-col  md="6" sm="12"  class="mt-2">
                    <p>
                        <span style="font-size: 17px;color:#2284ab;">Other Details</span> 
                    </p>
                    
                    <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;">
					          <b-form-group label="Do you recieve PF and ESIC ?" horizontal label-size="sm">
                      <b-form-radio-group id="radiospf" v-model="form.UserExprienceDetails.PFStatus" :options="PFStatusOptions" name="radioSubComponent">
                        
                      </b-form-radio-group>
                    </b-form-group> 
                    <b-form-group id="ing12" horizontal v-if="form.UserExprienceDetails.PFStatus"
                            label="PF No. / UAN <span style='color:red'>*</span>" label-size="sm"
                            label-for="inp12" description="Enter either PF Number in format MH/BAN/12345/1234567 or MH/12345/1234567 OR enter 12 digit UAN" >
                        <b-form-input type="text" 
                                size="sm" 
                                lazy-formatter
                                v-model="form.UserExprienceDetails.PFNO" :state="validatePF"
                                placeholder="PF Number"></b-form-input>    
                    </b-form-group>
					          <p style="font-size:0.75rem;color:red" class="mb-1" v-if="!form.UserExprienceDetails.PFStatus">You Need to Provide a Declaration from Employer about PF deduction.</p>
                    
                    <b-form-group id="ing13" horizontal v-if="form.UserExprienceDetails.PFStatus"
                            label="ESIC No. <span style='color:red'>*</span>" label-size="sm"
                            label-for="inp13">
                        <b-form-input type="text" 
                                size="sm" 
                                required
                                v-model="form.UserExprienceDetails.ESICNO"
                                placeholder="ESIC No."></b-form-input>    
                    </b-form-group>
                    <b-form-group id="ing14" horizontal
                            label="Basic Pay" label-size="sm"
                            label-for="inp14">
                        <b-form-input type="number" 
                                size="sm" 
                                v-model="form.UserExprienceDetails.BasicPay"
                                placeholder="Basic Pay"></b-form-input>     
                    </b-form-group>
                    <b-form-group id="ing15" horizontal
                            label="DA" label-size="sm"
                            label-for="inp15">
                        <b-form-input type="number" 
                                size="sm" 
                                v-model="form.UserExprienceDetails.DA"
                                placeholder="DA"></b-form-input>     
                    </b-form-group>
                    <b-form-group id="ing16" horizontal
                            label="Total Salary <span style='color:red'>*</span>" label-size="sm"
                            label-for="inp16">
                        <b-form-input type="number" 
                                size="sm" 
                                v-model="form.UserExprienceDetails.TotalSalary"
                                placeholder="Total Salary"></b-form-input>    
                    </b-form-group>
                    <b-form-group id="ing17" horizontal
                            label="Date of Joining <span style='color:red'>*</span>" label-size="sm"
                            label-for="inp17">
                        <!-- <b-form-input type="date" 
                                size="sm" 
                                v-model="form.UserExprienceDetails.StartDate"
                                placeholder="Date of Joining"></b-form-input>   -->
                        <date-picker                        
                        v-model="StartDate" 
                        format="DD-MM-YYYY" 
                        lang="en"                         
                        required size="small"></date-picker>  
                    </b-form-group>
                    <b-form-group id="ing18" horizontal
                            label="Last date of Working" label-size="sm"
                            label-for="inp18" v-if="form.UserExprienceDetails.workingStatus==2">
                        <!-- <b-form-input type="date" 
                                size="sm" 
                                v-model="form.UserExprienceDetails.EndDate"
                                placeholder="Last date of Working"></b-form-input>   -->
                        <date-picker v-model="EndDate" format="DD-MM-YYYY" lang="en" required size="small"></date-picker>
                    </b-form-group>
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                </b-col>
            </b-row>
            
            <b-row class="mt-2 justify-content-md-center" v-if="!LockProfile">
                <b-col md="4" sm="12" style="text-align:center">
                  <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
                  <b-alert :show = "showDismissibleAlert" dismissible 
                      @dismissed="showDismissibleAlert=false"
                      
                      :variant="variant">
                      {{alertText}}
                  </b-alert>
                </b-col>
                <b-col  md="4" sm="12" style="text-align:right">
                  <b-button type="submit" variant="primary">Submit</b-button>
                  <b-button type="reset" variant="danger">Reset</b-button>
                  <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
                </b-col>
            </b-row>
        </b-form>
    </b-container>
</template>
<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import DatePicker from "vue2-datepicker";
export default {
  name: "NomineeDetails",
  components: { Spinner, DatePicker },
  data() {
    return {
      workingStatus: [
        { value: 1, text: "Present" },
        { value: 2, text: "Past" }
      ],
      apntnature: [
        { value: 1, text: "Direct Employer" },
        { value: 2, text: "Through Agency" }
      ],
      PFStatusOptions:[
        {value:true, text:"Yes"},
        {value:false, text:"No"}
      ],
      // Md Tofiq (B) 28-2-19
      StartDate: null, 
      EndDate: null,
      PasaraValidityDate: null,
      // Md(E)
      form: {
        UserExprienceDetails: {
          AgencyName: "",
          AgencyAddress: 1,
          WorkingLocation: null,
          BasicPay: "",
          DA: "",
          TotalSalary: "",
          PFNO: "",
          ESICNO: "",
          StartDate: null,
          EndDate: null,
          AgencyContactNo: null,
          PrincipalEmployerName: "",
          PrincipalEmployerAddress: "",
          PrincipalContactNo: "",
          AppointmentType: "",
          workingStatus: "",
          PasaraLicense: "",
          PasaraValidityDate: "",
          PFStatus:true
        },
        LoginID: ""
      },

      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      saved: false
    };
  },
  computed: {
    getUser() {
      let x = this.$store.getters.getUserData;

      if (x) {
        return x;
      } else {
        return { LockProfile: false };
      }
    },
    LockProfile() {
      let userinfo = this.$store.getters.getUserData;
      if (userinfo) {
        return userinfo.LockProfile;
      } else {
        return false;
      }
    },
    getRegTyp() {
        return this.$store.getters.getRegTyp;
    },
    validatePF() {

      if (!this.form.UserExprienceDetails.PFStatus) {
        return true;
      }

      if (this.form.UserExprienceDetails.PFNO == null) {
        return false;
      }

      if (this.form.UserExprienceDetails.PFNO.length == 0) {
        return false;
      } else if (this.form.UserExprienceDetails.PFNO != null) {
        var pfFormat = /^([A-Z]{2}\/\d{5}\/([0-9]){7})|([A-Z]{2}\/[A-Z]{3}\/\d{5}\/[0-9]*)|\d{12}$/;
        if (this.form.UserExprienceDetails.PFNO.match(pfFormat)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validateWorkingDays() {
      var date1 = new Date(this.form.UserExprienceDetails.EndDate);
      var date2 = new Date(this.form.UserExprienceDetails.StartDate);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      let lastyear = new Date();
      lastyear.setYear(lastyear.getFullYear()-1);
      var timeDifflstYr = (date1.getTime()-lastyear.getTime());
      var diffdayslastyr = Math.ceil(timeDifflstYr / (1000 * 3600 * 24));
      
      let currentdate = new Date();

      var timediffcurrent = (currentdate.getTime() - date2.getTime());

      var diffdaysjoining = Math.ceil(timediffcurrent / (1000 * 3600 * 24));

      //return true;
      //var total_days = Math.abs(this.form.UserExprienceDetails.EndDate.getTime() - this.form.UserExprienceDetails.StartDate.getTime()) / (1000 * 60 * 60 * 24);
      if(this.form.UserExprienceDetails.workingStatus==1 || parseInt(this.getRegTyp) == 4){        
        if(diffdaysjoining >=60){
          return true;
        }
        else{
          return false;
        }
      }
      
      if (diffDays >= 60 && diffdayslastyr >=60 ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    get_date() {
                let date = new Date();
                let dd = date.getDate();
                let mm = date.getMonth() + 1;
                let yyyy = date.getFullYear();
                let new_date = yyyy + "-" + mm + "-" + dd;
                return new_date;

          },
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },

    // Md Tofiq (B) 28-2-19
    convertDateFormatYMD(inDate){
      let dbDateTime = new Date(inDate);
      let formattedDate = dbDateTime.getFullYear() + "-" + (dbDateTime.getMonth()+1) + "-" + dbDateTime.getDate();
      return formattedDate;
    },
    // Md(E)

    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;
      this.$store.dispatch("setPFStatus", this.form.UserExprienceDetails.PFStatus);

      // Md Tofiq (B) 28-2-19
      this.form.UserExprienceDetails.StartDate = this.convertDateFormatYMD(this.StartDate);
      this.form.UserExprienceDetails.EndDate = this.convertDateFormatYMD(this.EndDate);

      

      this.form.UserExprienceDetails.PasaraValidityDate = this.convertDateFormatYMD(this.PasaraValidityDate);
      this.newdate = this.convertDateFormatYMD();
      var currentDate = this.get_date();
     
      
      // Md (E)
     if (this.form.UserExprienceDetails.StartDate=='' || this.form.UserExprienceDetails.StartDate==null ||this.form.UserExprienceDetails.StartDate==undefined ||this.form.UserExprienceDetails.StartDate=='1970-1-1') {
        this.alertText = "Please Select Joining date";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
        
      }   
      if (new Date(this.form.UserExprienceDetails.StartDate)>new Date(currentDate)) {
        this.alertText = "Date of Joining Should Not be greater than current date";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
        
      }

       if (new Date(this.form.UserExprienceDetails.EndDate)>new Date(currentDate)) {
        this.alertText = "Last date of Working Should Not be greater than current date";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
        
      }
      if (!this.validatePF) {
        this.alertText = "Please verify the PF Number";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }

      if (!this.validateWorkingDays) {
        this.alertText = "The working days in last one year are less than 60.";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
       if (this.form.UserExprienceDetails.PrincipalContactNo.length>15) {
        this.alertText = "Please Enter Valid Principal Employer Contact No.";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }

      var userinfo = this.$store.getters.loggedUser;
      this.form.LoginID = userinfo.UserId;
      let promise = apis.saveUserExperience(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.saved = false;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {},
    getExperience() {
      var userinfo = this.$store.getters.loggedUser;
      let promise = apis.ReadUserExperience(userinfo.UserId);

      promise
        .then(response => {
          //console.log('Nominee Reponse' ,response);
          if (response.status == 200) {
            this.form.UserExprienceDetails = response.body;
            this.$store.dispatch("setPFStatus", this.form.UserExprienceDetails.PFStatus);
            // Md Tofiq (B)  28-2-19
            this.StartDate = this.form.UserExprienceDetails.StartDate;
            this.EndDate = this.form.UserExprienceDetails.EndDate;
            this.PasaraValidityDate = this.form.UserExprienceDetails.PasaraValidityDate;
            // Md (E)


            // this.form.UserExprienceDetails.StartDate = response.body.StartDate.split(
            //   "T"
            // )[0];
            // this.form.UserExprienceDetails.EndDate = response.body.EndDate.split(
            //   "T"
            // )[0];
            // this.form.UserExprienceDetails.PasaraValidityDate = response.body.PasaraValidityDate.split(
            //   "T"
            // )[0];

            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  },
  mounted() {
    this.getExperience();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/RegistrationDetails/Experience.vue